let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("aJWAE")).then(() => parcelRequire('7qoEH'));